import { store } from 'store'
import { RegistrationRequiredProps } from './Enums'

export const isFloat = (n) => typeof n === 'number' && n % 1 !== 0

export const getUpdatedCursorPosition = (cursorPosition, previousValue, currentValue) => {
    const valueLengthDiff = currentValue.replace(/[^+\d]/g, '').length - previousValue.replace(/[^+\d]/g, '').length
    const leftDigitsCount = previousValue.slice(0, cursorPosition).replace(/[^+\d]/g, '').length
    const valueArray = currentValue.split('')
    let updatedCursorPosition = 0
    let counter = 0

    // Iterate over chars
    for (const char of valueArray) {
        // Count digits only (as we want to ignore any potential non-digit characters)
        if (/[+\d]/g.test(char)) {
            counter++
        }

        // Check if we reached the last digit that was before the cursor before the change
        if (counter > leftDigitsCount + valueLengthDiff) {
            break
        }

        // Increment cursor position
        updatedCursorPosition++
    }

    return updatedCursorPosition
}

export const sendNotification = (header, message, onclick = () => window.focus()) => {
    if (
        !store.getState().global.isNotificationPermissionDenied &&
        (window.Notification || Notification.requestPermission)
    ) {
        try {
            const notification = new Notification(header, {
                icon: '/images/logo.png',
                body: message
            })
            notification.onclick = onclick
        } catch (e) {
            if (e.name === 'TypeError') {
                return false
            }

            console.error(e)
        }
    }
}

export const validateRegistationProps = (regData) => {
    const initData = {}

    RegistrationRequiredProps.forEach((key) => {
        initData[key] = regData?.hasOwnProperty(key) ? regData[key] : null
    })

    return !Object.values(initData).some((item) => item == null)
}

export const getLeadTitle = (props) => {
    let title = ''
    const { firstname = '', lastname = '', email = '', number = '', phone = '', mobilephone = '' } = props

    if (firstname || lastname) {
        title = [firstname, lastname].filter(Boolean).join(' ')
    } else {
        title = email || number || phone || mobilephone
    }

    return title
}
